import React from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Grid } from 'react-flexgrid';

import { rhythm } from '../utils/typography';
import Header from './Header';

import '../global.css';
import '../animate.css';

import ContactModal from './ContactModal';

const Footer = styled.footer`
    margin-top: 60px;
    
    @media (max-width: 745px) {
      margin-top: 20px;
    }
    
    font-family: "futura-pt", sans-serif;
`;

const Nav = styled.div`
  display: flex;
  margin-bottom: 32px;
  
  @media (max-width: 745px) {
      margin-bottom: 20px;
  }
`;

const StyledLink = styled(Link)`
font-size: 30px;
font-family: Futura, sans-serif;
text-decoration: none;
line-height: 40px;
font-weight: 700;
 margin-right: 25px;
 opacity: 0.25;
`;


class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isContactFormOpen: false,
    };

    this.toggleContactModal = this.toggleContactModal.bind(this);
  }

  toggleContactModal() {
    const { isContactFormOpen } = this.state;
    this.setState({ isContactFormOpen: !isContactFormOpen });
  }

  render() {
    const { children, includeHeader } = this.props;
    const { isContactFormOpen } = this.state;
    return (
      <Grid
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: 900,
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        }}>
        {includeHeader && (
          <Header
            didClickContact={this.toggleContactModal}
            title="Alexander Catchpole"
            subtitle="Software Engineer @ Langley Foxall"
          />
        )}
        {includeHeader && (
          <Nav>
            <StyledLink
              to="/"
              activeStyle={{ opacity: 1 }}
            >
              Blog
            </StyledLink>
            <StyledLink
              to="/projects"
              activeStyle={{ opacity: 1 }}
            >
              Projects
            </StyledLink>
          </Nav>
        )}
        {children}
        <Footer>
          © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.gatsbyjs.org">Gatsby</a>
          {` `}
          &
          {` `}
          <a href="https://github.com/emotion-js/emotion">Emotion</a>
        </Footer>
        <ContactModal toggle={this.toggleContactModal} isOpen={isContactFormOpen} />
      </Grid>
    )
  }
}

export default Layout;
